module.exports = __webpack_public_path__ + "img/53.8e70e3ef.jpg";